import React from 'react';
import * as images from '../../assets/images';
import InterceptedLi from '../../components/IntereptedLi/InterceptedLi';
import { clss } from '../../utils/helpers/styleHelpers';

import styles from './features.module.scss';

const FEATURES = [
    {
        title: 'Quick Quality Check',
        description: 'The system validates video length and resolution before sending to broadcasters',
    },
    {
        title: 'Fast Ad Delivery',
        description: 'An advanced tool optimized to allow for stable and fast uploading of large media files',
    },
    {
        title: 'Online Ad Preview',
        description: 'View the commercial online before downloading and broadcasting',
    },
    {
        title: 'Multiuser Collaboration',
        description: 'Collaborate with others using multiple users with authorization levels',
    },
    {
        title: 'Advanced Notifications',
        description: 'Choose when you to get notified during the workflow process',
    },
    {
        title: 'Cross Device Support',
        description: 'Advanced and responsive interface allowing for cross device use – iOS, Android, PC, Mac',
    },
    {
        title: 'Server Integration',
        description: 'Automatic delivery of media files directly to the broadcaster\'s server',
    },
    {
        title: 'Real-Time Tracking',
        description: 'Keep track of the delivery process at any time and any stage',
    },
    {
        title: 'Secure Sharing',
        description: 'We take security seriously, your content is in good hands',
    },
];

const Features = () => {
    return (
        <main className={styles.mainWrapper}>
            <h1>Why JumboMedia?</h1>
            <ul className={styles.featureList}>
                {FEATURES.map((feature, index) => (
                    <InterceptedLi
                        handledElementId={`description-${index}`}
                        key={feature.title}
                    >
                        <img src={images[`feature${index}`]} alt={feature.title} />
                        <h2>{feature.title}</h2>
                        <div className={clss([styles.description])} id={`description-${index}`}>
                            <p>{feature.description}</p>
                        </div>
                    </InterceptedLi>
                ))}
            </ul>
        </main>
    );
};

export default Features;